import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const EquipmentStep = ({ selectedEquipment, onToggle, hasOwnBoard, onBoardOwnershipChange }) => {
  const equipmentTypes = [
    {
      id: 'inflatable',
      name: 'Şişme SUP',
      icon: 'Wind',
      description: 'Taşıması kolay, dayanıklı'
    },
    {
      id: 'hardboard',
      name: 'Sert Tahta',
      icon: 'Waves',
      description: 'Yüksek performans, hızlı'
    },
    {
      id: 'paddle',
      name: 'Kürek',
      icon: 'Minus',
      description: 'Ayarlanabilir veya sabit'
    },
    {
      id: 'leash',
      name: 'Leash (Güvenlik İpi)',
      icon: 'Link',
      description: 'Güvenlik için zorunlu'
    },
    {
      id: 'pfd',
      name: 'Can Yeleği',
      icon: 'Shield',
      description: 'Güvenlik ekipmanı'
    },
    {
      id: 'wetsuit',
      name: 'Wetsuit',
      icon: 'Shirt',
      description: 'Soğuk sular için'
    }
  ];

  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
      <div className="text-center mb-8 md:mb-10 lg:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-3 md:mb-4">
          Ekipman Durumunuz
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
          Sahip olduğunuz ekipmanları seçin. Bu bilgi size uygun etkinlikleri önermemize yardımcı olacak
        </p>
      </div>
      <div className="bg-[var(--color-card)] rounded-xl md:rounded-2xl p-6 md:p-8 border border-[var(--color-border)] mb-6 md:mb-8">
        <Checkbox
          label="Kendi SUP tahtam var"
          description="Etkinliklere kendi ekipmanınızla katılabilirsiniz"
          checked={hasOwnBoard}
          onChange={(e) => onBoardOwnershipChange(e?.target?.checked)}
          size="lg"
        />
      </div>
      {hasOwnBoard && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6">
          {equipmentTypes?.map((equipment) => {
            const isSelected = selectedEquipment?.includes(equipment?.id);
            
            return (
              <button
                key={equipment?.id}
                onClick={() => onToggle(equipment?.id)}
                className={`p-5 md:p-6 lg:p-7 rounded-xl md:rounded-2xl border-2 transition-smooth text-left ${
                  isSelected
                    ? 'border-[var(--color-primary)] bg-[rgba(27,75,102,0.08)] shadow-organic'
                    : 'border-[var(--color-border)] bg-[var(--color-card)] hover:border-[var(--color-primary)] hover:shadow-organic-sm'
                }`}
              >
                <div className="flex items-start gap-4 mb-3 md:mb-4">
                  <div
                    className={`w-12 h-12 md:w-14 md:h-14 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0 ${
                      isSelected
                        ? 'bg-[var(--color-primary)] text-[var(--color-primary-foreground)]'
                        : 'bg-[var(--color-muted)] text-[var(--color-muted-foreground)]'
                    }`}
                  >
                    <Icon name={equipment?.icon} size={24} />
                  </div>
                  {isSelected && (
                    <Icon name="CheckCircle2" size={20} className="text-[var(--color-primary)] flex-shrink-0" />
                  )}
                </div>
                <h3 className="text-base md:text-lg font-semibold text-[var(--color-foreground)] mb-2">
                  {equipment?.name}
                </h3>
                <p className="text-sm md:text-base text-[var(--color-muted-foreground)]">
                  {equipment?.description}
                </p>
              </button>
            );
          })}
        </div>
      )}
      {!hasOwnBoard && (
        <div className="bg-[var(--color-muted)] rounded-xl md:rounded-2xl p-6 md:p-8 lg:p-10 text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-[var(--color-secondary)] rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
            <Icon name="Info" size={32} className="text-[var(--color-secondary-foreground)]" />
          </div>
          <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-[var(--color-foreground)] mb-3 md:mb-4">
            Ekipman Kiralama Seçenekleri
          </h3>
          <p className="text-sm md:text-base lg:text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
            Endişelenmeyin! Çoğu etkinlikte ekipman kiralama imkanı bulunmaktadır. Etkinlik detaylarında kiralama fiyatlarını görebilirsiniz.
          </p>
        </div>
      )}
    </div>
  );
};

export default EquipmentStep;